import { render, staticRenderFns } from "./ThirdPartyQuestion.vue?vue&type=template&id=1a445583"
import script from "./ThirdPartyQuestion.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ThirdPartyQuestion.vue?vue&type=style&index=0&id=1a445583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports